import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-2 px-1 font-medium text-gray-600"
}
const _hoisted_2 = {
  key: 0,
  class: "text-xs mb-1"
}
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = { class: "flex-none mr-2" }
const _hoisted_5 = { class: "whitespace-pre-line break-all pt-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs mb-1 text-right"
}
const _hoisted_7 = { class: "flex items-start justify-end" }
const _hoisted_8 = { class: "whitespace-pre-line break-all pt-2" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex-none ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_avatar = _resolveComponent("base-avatar")!

  return (_ctx.videoQuestion)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (_ctx.videoQuestion.created_at)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.datetimeFormatter(_ctx.videoQuestion.created_at)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_avatar)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.videoQuestion.message), 1)
          ])
        ]),
        (_ctx.videoQuestion.video_question_answer)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.videoQuestion.video_question_answer.created_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.datetimeFormatter(_ctx.videoQuestion.video_question_answer.created_at)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "v-html whitespace-pre-wrap mb-6",
                    innerHTML: _ctx.videoQuestion.video_question_answer.message
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_avatar, {
                    imageUrl: _ctx.videoQuestion.video_question_answer.manager.avatar
                  }, null, 8, ["imageUrl"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}